import "./benefitsList.scss";
import { ProgressBar } from "react-bootstrap";
import BenefitsHead from "../../../../BenefitsHead";
import BenefitConditions from "../../../../BenefitConditions";
import SbLoading from "../../../../../../../../common/SbLoading";
import Typography from "../../../../../../../../common/Typography";
import CheckVerified from "../../../../../../../../assets/CheckVerified";

const BenefitsList = ({ benefits, currencyView, isLoadingRewards }) => {
  return (
    <>
      <BenefitsHead />
      {isLoadingRewards ? (
        <SbLoading />
      ) : (
        <div className="benefits-list">
          {benefits?.map((benefit, i) => (
            <BenefitCard
              key={benefit?._id || benefit?.id || i}
              benefit={benefit}
              currencyView={currencyView}
            />
          ))}
        </div>
      )}
    </>
  );
};

export default BenefitsList;

const BenefitCard = ({ benefit, currencyView }) => {
  const isShowProgressBar =
    benefit?.redemption?.mode === "multiple" &&
    benefit?.redemptions_till_date >= 0 &&
    benefit?.redemption_limit >= 0 &&
    benefit?.redemptions_till_date < benefit?.redemption_limit;
  const isShowBenefitsRedeemed =
    benefit?.redemptions_till_date >= 0 &&
    benefit?.redemption_limit >= 0 &&
    benefit?.redemptions_till_date === benefit?.redemption_limit;

  return (
    <div
      className={`benefit-card${
        isShowBenefitsRedeemed ? " benefit-card--redeemed" : ""
      }`}
    >
      {isShowBenefitsRedeemed && (
        <div className="benefits-redeemed">
          <CheckVerified width={18} height={18} bgcolor="#059669" />
          <Typography size="text-xs" weight="medium">
            Benefit Redeemed
          </Typography>
        </div>
      )}
      <div className="benefit-card-head">
        <div className="benefit-info">
          <Typography
            weight="medium"
            size="display-lg"
            customClass="benefit-title"
          >
            {benefit?.name ?? benefit?.reward_name ?? ""}
          </Typography>
          {benefit?.description?.length > 0 ? (
            <Typography size="text-md" customClass="description">
              {benefit?.description}
            </Typography>
          ) : (
            <></>
          )}
          <BenefitConditions reward={benefit} currencyView={currencyView} />
        </div>
        {benefit?.reward_type ? (
          <img
            alt={benefit?.reward_type}
            src={`/assets/images/membership/${benefit?.reward_type}.png`}
          />
        ) : (
          <></>
        )}
      </div>
      {isShowProgressBar && (
        <div className="redemption-progress-div">
          <Typography
            size="text-sm"
            weight="medium"
            customClass="redemption-text"
          >
            Redemption
          </Typography>
          <div className="redemption-numbers-row">
            <Typography size="text-sm" weight="medium">
              {benefit?.redemptions_till_date}
            </Typography>
            <Typography size="text-sm" weight="medium">
              {benefit?.redemption_limit}
            </Typography>
          </div>
          <ProgressBar
            now={benefit?.redemptions_till_date}
            max={benefit?.redemption_limit}
          />
        </div>
      )}
    </div>
  );
};
